import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import * as React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/app-logo.svg';
import StyledHeader from './styled/Header';
import { Title } from './Title';
import { UserMenu } from './UserMenu';
import Notifications from './Notifications';
import { Utils } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import Icon, { IconColor, IconType } from '../../media/Icon';
import { inject, observer } from 'mobx-react';
import { StoreName } from '../../../shared/stores/StoreName';
import Tooltip from '../../info/Tooltip';
import { TooltipType } from '../../../components/info/Tooltip/TooltipType';
import translate from '../../i18n/translate';

var Header =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _getPrototypeOf(Header).apply(this, arguments));
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      return React.createElement(StyledHeader, {
        style: {
          backgroundColor: this.envBackground
        }
      }, React.createElement("div", {
        className: "header-logo"
      }, React.createElement(Link, {
        to: "/"
      }, React.createElement("img", {
        src: logo
      }))), this.showEnvIcon && React.createElement("div", {
        className: "header-env"
      }, React.createElement(Tooltip, {
        tooltipType: TooltipType.Info,
        placement: "right",
        overlay: React.createElement("div", null, translate("app_environment-".concat(this.props.store.config.mode))),
        children: React.createElement("div", null, React.createElement(Icon, {
          iconType: this.envIconType,
          iconColor: this.envIconColor,
          iconHeight: 23
        }))
      })), React.createElement(Title, {
        appSwitchEnabled: true,
        appLive: this.props.store.config.mode === 'live'
      }), this.props.notificationRenderer && React.createElement(Notifications, {
        renderer: this.props.notificationRenderer
      }), Utils.isValueMissing(CONSTANTS.KEYCLOAK.CONFIG.bearer) && React.createElement(UserMenu, {
        isSystemAdmin: false,
        substitutionLink: this.props.substitutionLink
      }));
    }
  }, {
    key: "showEnvIcon",
    get: function get() {
      switch (this.props.store.config.mode) {
        case 'demo':
        case 'development':
        case 'stage':
        case 'ahold-test':
        case 'test':
        case 'e2e':
          return true;

        case 'live':
        default:
          return false;
      }
    }
  }, {
    key: "envIconColor",
    get: function get() {
      return IconColor.Green;
    }
  }, {
    key: "envIconType",
    get: function get() {
      return IconType.alert;
    }
  }, {
    key: "envBackground",
    get: function get() {
      switch (this.props.store.config.mode) {
        case 'demo':
          // todo custom color
          return '#FFFFFF';

        case 'development':
          return '#FFF7C4';

        case 'stage':
          return '#B5E6B8';

        case 'ahold-test':
          return '#D5F2FD';

        case 'test':
          return '#E9D6FF';

        case 'e2e':
          return '#FFE1D4';

        case 'live':
        default:
          return '';
      }
    }
  }]);

  return Header;
}(React.Component);

Header = __decorate([inject(function (allStores) {
  return {
    store: allStores[StoreName.GeneralConfigurations]
  };
}), observer], Header);
export { Header };